// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-35Mz9","btnDetail":"index-btnDetail-lTngh","active":"index-active-2oJcg"};